import { render, staticRenderFns } from "./WebRegister.vue?vue&type=template&id=5273da88&"
import script from "./WebRegister.vue?vue&type=script&lang=js&"
export * from "./WebRegister.vue?vue&type=script&lang=js&"
import style0 from "./WebRegister.vue?vue&type=style&index=0&id=5273da88&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports